/**
 * Zero Robotics C++ Generator
 *
 * Procedure blocks converted from the legacy
 * Zero Robotics Blockly generator.
 */

import * as Blockly from "blockly";
import { zrCppGenerator } from "./zrCppGenerator";


// ============================================================
// Helper: get procedure name
// ============================================================

function getProcedureName(block) {

    const name =
        block.getFieldValue("NAME");

    return name || "procedure";
}


// ============================================================
// procedures_defreturn
// ============================================================

zrCppGenerator.forBlock["procedures_defreturn"] =
    function(block) {

        const funcName =
            getProcedureName(block);

        const branch =
            this.statementToCode(
                block,
                "STACK"
            );

        const type =
            block.getFieldValue("TYPE") ||
            "void";

        const returnValue =
            this.valueToCode(
                block,
                "RETURN",
                this.ORDER_NONE
            ) || "";

        let code =
            type +
            " " +
            funcName +
            block.getArgString(true) +
            " {\n" +
            branch;

        if (returnValue) {
            code +=
                "  return " +
                returnValue +
                ";\n";
        }

        code += "}";

        return code;
    };


// ============================================================
// procedures_defnoreturn
//
// Same generator as procedures_defreturn
// ============================================================

zrCppGenerator.forBlock["procedures_defnoreturn"] =
    zrCppGenerator.forBlock["procedures_defreturn"];


// ============================================================
// procedures_definit
// ============================================================

zrCppGenerator.forBlock["procedures_definit"] =
    function(block) {

        const globals =
            this.statementToCode(
                block,
                "GLOBALS"
            );

        const branch =
            this.statementToCode(
                block,
                "STACK"
            );

        const code =
            "void init() {\n" +
            globals +
            branch +
            "}";

        return code;
    };


// ============================================================
// procedures_defloop
// ============================================================

zrCppGenerator.forBlock["procedures_defloop"] =
    function(block) {

        const branch =
            this.statementToCode(
                block,
                "STACK"
            );

        const code =
            "void loop() {\n" +
            branch +
            "}";

        return code;
    };


// ============================================================
// procedures_callreturn
// ============================================================

zrCppGenerator.forBlock["procedures_callreturn"] =
    function(block) {

        const funcName =
            getProcedureName(block);

        const args = [];

        for (
            let x = 0;
            x < block.arguments_.length;
            x++
        ) {

            args[x] =
                this.valueToCode(
                    block,
                    "ARG" + x,
                    this.ORDER_COMMA
                ) || "null";
        }

        const code =
            funcName +
            "(" +
            args.join(", ") +
            ")";

        return [
            code,
            this.ORDER_FUNCTION_CALL
        ];
    };


// ============================================================
// procedures_callnoreturn
// ============================================================

zrCppGenerator.forBlock["procedures_callnoreturn"] =
    function(block) {

        const funcName =
            getProcedureName(block);

        const args = [];

        for (
            let x = 0;
            x < block.arguments_.length;
            x++
        ) {

            args[x] =
                this.valueToCode(
                    block,
                    "ARG" + x,
                    this.ORDER_COMMA
                ) || "null";
        }

        const code =
            funcName +
            "(" +
            args.join(", ") +
            ");\n";

        return code;
    };


// ============================================================
// procedures_ifreturn
// ============================================================

zrCppGenerator.forBlock["procedures_ifreturn"] =
    function(block) {

        const condition =
            this.valueToCode(
                block,
                "CONDITION",
                this.ORDER_NONE
            ) || "false";

        let code =
            "if (" +
            condition +
            ") {\n";

        if (block.hasReturnValue_) {

            const value =
                this.valueToCode(
                    block,
                    "VALUE",
                    this.ORDER_NONE
                ) || "null";

            code +=
                "  return " +
                value +
                ";\n";

        } else {

            code +=
                "  return;\n";
        }

        code += "}\n";

        return code;
    };